import { useCallback, useEffect, useState } from "react";
import { Dimensions, View, ScrollView, Text, Image, ActivityIndicator, TouchableOpacity, FlatList, StyleSheet, Pressable } from "react-native";
import * as FileSystem from 'expo-file-system';
import { ArticleJSON, Magazine } from "@/services/Datatypes";
import { readLocalJsonFile } from "@/services/readLocalJsonFile";
import { router, useLocalSearchParams } from "expo-router";

import Ionicons from '@expo/vector-icons/Ionicons';
import { type IconProps } from '@expo/vector-icons/build/createIconSet';

import Animated, { FadeIn, SlideInDown } from 'react-native-reanimated';

import { Asset, useAssets } from 'expo-asset';

import { decode } from 'html-entities';

import 'keen-slider/keen-slider.min.css';
import '../components/styles/webKeenSlider.css';
import { useKeenSlider } from 'keen-slider/react';


import { useBoundStore } from '@/services/zustand/Store.web';



export const getArticleJson = async (date: any, edition: any) => {

    return new Promise(async (resolve, reject) => {

        const pageNo = useBoundStore.getState().currentPage;
        
        const articleJsonData: any = await fetch(
            '/web-server-api/getJson',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "type": 'articleJson',
                    "date": date,
                    "edition": edition,
                    "pageNo": pageNo
                }),
            }
        );

        const data = await articleJsonData.json();
        
        if(data) {
            resolve(data.jsonData);
        }
        else {
            reject('no_data');
        }

    });

};

export const getArticleImage = async (date: any, edition: any, image: any) => {

    return new Promise(async (resolve, reject) => {

        const pageNo = useBoundStore.getState().currentPage;
        
        const articleImageData: any = await fetch(
            '/web-server-api/getImage',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "type": 'articleImage',
                    "date": date,
                    "edition": edition,
                    "pageNo": pageNo,
                    "image": image
                }),
            }
        );
    
        const data = await articleImageData.json();
        const imageBase64 = data.base64ImageStr;
        
        if(imageBase64) {
            resolve({ uri: `${imageBase64}` });
        }
        else {
            reject(false);
        }
    });

    

};

export function ArticleContent() {

} 

export default function ArticleModal() {
    //const [isVisible, setIsVisible] = useState(true);

    const isVisible: boolean = useBoundStore(useCallback((state) => state.isVisible, []));
    const articleId: string = useBoundStore(useCallback((state) => state.articleId, []));
    const date: string = useBoundStore(useCallback((state) => state.date, []));
    const edition: string = useBoundStore(useCallback((state) => state.edition, []));

    //const { magazine, articleID, date, edition } = useLocalSearchParams()
    //const parsedMagazine: Magazine = magazine ? JSON.parse(magazine as string) : null;
    const [loading, setLoading] = useState(true);
    const [articleJsonData, setArticleJsonData] = useState<Object | null>(null);
    // processedArticleData
    const [processedArticleData, setProcessedArticleData] = useState<any | null>(null);
    const [articleData, setArticleData] = useState<ArticleJSON | null>(null);
    const [articleImages, setArticleImages] = useState<Array<string> | null>(null);

    //const [articleItems, setArticleItems] = useState<Array<any> | null>(null);

    let articleItems: any = []; 
    
    const [content, setContent] = useState([]);
    const [image, setImage] = useState(null);

    const closeModal = () => {
        useBoundStore.getState().updateIsVisible(false);
    };

    const renderContent = (item: any) => {

        switch(item.type) {

            case 'headline':
                return (
                <View>
                    <Text style={styles.title}>{ item.content }</Text>
                </View>
                );
            break;
        
            case 'subtitle':
                return (
                <View>
                    <Text style={ styles.subtitle }>{ item.content }</Text>
                </View>
                );
            break;
        
            case 'paragraph':
                return (
                <View>
                    <Text style={ styles.paragraph }>{ item.content }</Text>
                </View>
                );
            break;
        
            case 'images':

                const imagesLength = item.content.length;

                if(imagesLength > 1) {
                    return (
                        <View>
                            <div 
                                className="navigation-wrapper"
                                style={{
                                    //width: visibleWidthRef.current,
                                    //height: visibleHeightRef.current,
                                }}
                            >
                                <div ref={sliderRef} className="keen-slider">
        
                                    {Array.from(
                                        item.content,
                                        (el, index) => (
                                            <div
                                                key={`image_slide_${index + 1}`} 
                                                className={`keen-slider__slide number-slide${index + 1}`}
                                            >
                                                <Image
                                                    source={ articleImages[index] }
                                                    resizeMode={ 'contain' }
                                                    style={{ width: '100%', minHeight: 400 }}
                                                />
                                            </div>
                                        )
                                    )}
                                        
                                </div>
        
                                <>
                                    <Arrow
                                        left
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.prev()
                                        }
                                        disabled={currentSlide === 0}
                                    />
        
                                    <Arrow
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.next()
                                        }
                                        disabled={
                                            //currentSlide === instanceRef.current?.track.details.slides.length - 1
                                            currentSlide === (imagesLength - 1)
                                        }
                                    />
                                </>
        
                            </div>
                        </View>
                    );
                }
                else {
                    return (
                        <View>
                            <Image
                                source={ articleImages[0] }
                                resizeMode={ 'contain' }
                                style={{ width: '100%', minHeight: 400 }}
                            />
                        </View>
                    );
                }




        
                
            break;
        
            default: break;
        }
    
        
    }
    
    const processArticleData = async (articleData: any) => {
        return new Promise((resolve, reject) => {

            let flatListContent: any = [], contentCnt = 0;

            // { uri: `../epaper/${parsedMagazine.date}/img/${articleData.articleData.images[0]}` }

            if(articleData.articleData.images.length > 0) {



                flatListContent.push({
                    id: contentCnt,
                    type: 'images',
                    content: articleData.articleData.images
                });


                contentCnt++;
            }
      
            if(articleData.articleData.headline !== '') {
                flatListContent.push({
                    id: contentCnt,
                    type: 'headline',
                    content: decode(articleData.articleData.headline)
                });
                contentCnt++;
            }
    
            if(articleData.articleData.kicker !== '') {
                flatListContent.push({
                    id: contentCnt,
                    type: 'subtitle',
                    content: decode(articleData.articleData.kicker)
                });
                contentCnt++;
            }

            if(articleData.articleData.paragraph.length > 0) {
                for(const [a, paragraph] of articleData.articleData.paragraph.entries()) {

                    flatListContent.push({
                        id: contentCnt,
                        type: 'paragraph',
                        content: decode(paragraph)
                    });
                
                    contentCnt++;
                
                    if(a === (articleData.articleData.paragraph.length - 1)) {
                        //setContent(flatListContent);
                        //setLoading(false);
                        //resolve(true);
                    }
                }
            }

            if(articleData.articleData.content !== '') {

                if(typeof articleData.articleData.content === 'string') {
                    flatListContent.push({
                        id: contentCnt,
                        type: 'paragraph',
                        content: decode(articleData.articleData.content)
                    });

                    contentCnt++;

                    setContent(flatListContent);
                    resolve(true);

                }
                else {
                    for(const [a, paragraph] of articleData.articleData.content.entries()) {

                        flatListContent.push({
                            id: contentCnt,
                            type: 'paragraph',
                            content: decode(paragraph)
                        });
                    
                        contentCnt++;
                    
                        if(a === (articleData.articleData.content.length - 1)) {
                            setContent(flatListContent);
                            //setLoading(false);
                            resolve(true);
                        }
                    }
                }

                
            }
            else {
                setContent(flatListContent);
                resolve(true);
            }

            


        });
    };

    // Slider
    const [sliderLoaded, setSliderLoaded] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0)
    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        //initial: 1,
        renderMode: 'performance',
        //mode: "free",
        slides: {
            origin: 'center',
            //perView: 1,
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel)
        },
        created() {
            setSliderLoaded(true)
        },
    });

    const Arrow = (props: {
        disabled: boolean
        left?: boolean
        onClick: (e: any) => void
    }) => {
        const disabled = props.disabled ? " arrow--disabled" : ""
        return (
            <svg
                onClick={props.onClick}
                className={`arrow ${
                    props.left ? "arrow--left" : "arrow--right"
                } ${disabled}`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
            >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && (
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
            )}
            </svg>
        )
    };







    useEffect(() => {

        if(isVisible) {

            setLoading(true);
            setContent([]);

            const prepareArticle = async () => {
    
                if (typeof articleId === 'string') {
    
                    try {
                        let articleJSON: any | null = await getArticleJson(date, edition);
    
                        if(articleJSON) {
                            const foundArticle = await articleJSON?.find((article: any) => {
                                return article.id === articleId;
                            });
    
                            let base64ImageArray: Array<string> = [];
    
                            const imagesLength = foundArticle.articleData.images.length;
    
                            if(imagesLength > 0) {
                                for(const [key, image] of foundArticle.articleData.images.entries()) {
                                    const base64Image: any = await getArticleImage(date, edition, image);
    
                                    if(base64Image) {
                                        base64ImageArray.push(base64Image);
                                    }
    
                                    if(key === (imagesLength - 1)) {
                                        setArticleImages(base64ImageArray);
                                        setLoading(false);
                                    }
                                }
                            }
        
                            setArticleData(foundArticle ? foundArticle : null);

                            const processedArticleData = await processArticleData(foundArticle);
                            
                            if(processedArticleData) {

                                setProcessedArticleData(processedArticleData);

                                setLoading(false);
                            }
                            
                        }
                    }
                    catch(error) {
                        console.error('Error reading article json:', error);
                    }
                    finally {
                        setLoading(false);
                    }
                }
            }
    
            prepareArticle();
        }
        else {
            
        }
        
    }, [isVisible, articleId, articleJsonData]);



    if(!isVisible) {
        return (
            <View></View>
        );
    }

    return (
        <View
            //entering={FadeIn}
            style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                backgroundColor: '#00000040',
                width: '100%',
                height: "100%",
                //minHeight: '100%',
                //maxHeight: '100%',
                position: 'absolute',

                //borderWidth: 1,
                //borderColor: 'red',
            }}
        >

            {loading && (
                <ActivityIndicator size="large" color="#0000ff" />
            )}

            {!loading && (

            <View
                style={{
                    flex: 1,
                    maxWidth: '50%',
                    maxHeight: '90%',
                    backgroundColor: '#fff',
                }}
            >
                <View
                    style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        minHeight: 60,
                        padding: 10,
                        marginBottom: 10,
                        backgroundColor: '#006699',
                    }}
                >
                    <TouchableOpacity 
                        onPress={ closeModal }
                        style={{
                            //flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: 40,
                            height: 40,
                            borderRadius: 20,
                            backgroundColor: 'white'
                        }}
                    >
                        <Ionicons 
                            name="close"
                            size={28} 
                            style={{
                                color: '#006699',
                                fontWeight: 'bold',
                            }}

                        />
                    </TouchableOpacity>
                </View>
                <View
                    style={{
                        flex: 1
                    }}
                >
                    {
                        /*
                        <FlatList 
                            data={content}
                            renderItem={ renderContent }
                            keyExtractor={(item: any) => item.id}
                            scrollEnabled={ true }
                            nestedScrollEnabled={ true }
                            //style={{flex: 1}}
                        />
                        */
                    }
                    


                    <ScrollView 
                        nestedScrollEnabled={ true }
                        style={{
                            position: 'relative'
                        }}
                    >
                    {content.map((item: any, index: number) => (
                        renderContent(item)
                    ))}
                    </ScrollView>
                </View>
                
            </View>

            )}

        </View>
        
    );

    


/*
    return (
        <Animated.View
            entering={FadeIn}
            style={{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',

                

                backgroundColor: '#00000040',
            }}
        >
            <ScrollView style={{
                //flex:1,
                //flexDirection: 'column',
                //justifyContent: 'center',
                //alignItems: 'center',
                maxWidth: '50%',
                maxHeight: '75%',

                backgroundColor: '#fff',

                padding: 10,                


                //borderWidth: 1,
                //borderColor: 'green',
            }}>
                {loading ? (
                    <ActivityIndicator size="large" color="#0000ff" />
                ) : (
                    <>
                        {articleData !== null ? (
                            <>
                                {articleData.articleData.images.length > 0 && (
                                    <Image
                                        source={{ uri: `../epaper/${parsedMagazine.date}/img/${articleData.articleData.images[0]}` }}
                                        style={{ width: '100%', minHeight: 200 }}
                                    />
                                )}
                                {articleData.articleData.headline !== "" ? (
                                    <Text style={{ color:'#fff', marginBottom: 10 }}>{articleData.articleData.headline}</Text>
                                ) : null}
                                {articleData.articleData.content.length > 0 && (
                                    <>
                                    <Text
                                        style={{
                                            color:'#333',
                                            fontFamily: 'Roboto',
                                            textAlign: 'left',
                                            lineHeight: 28,
                                            fontSize: 18,
                                            margin: 10,
                                            width: '95%',
                                            alignSelf: 'center',
                                            alignItems: 'center',
                                        }}>{ articleData.articleData.content }</Text>
                                        <TouchableOpacity onPress={() => router.back()}
                                        style={{
                                        width: '80%',
                                        padding: 10,
                                        backgroundColor: '#069',
                                        borderRadius: 8,
                                        alignSelf: 'center',
                                        alignItems: 'center',
                                        }}>
                                        <Text style={{ color: '#fff' }}>Schließen</Text>
                                    </TouchableOpacity>
                                    </>
                                )}
                            </>
                        ) : (
                            <Text style={{ color: '#fff' }}>Article not found.</Text>
                        )}
                    </>
                )
                }
            </ScrollView>
        </Animated.View>
        
    );
*/
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      //alignItems: 'flex-start',
      //justifyContent: 'flex-start',
    },
    webview: {
      flex: 1,
  
      //alignItems: 'flex-start',
      //justifyContent: 'flex-start',
  
      //borderWidth: 1,
      //borderColor: 'red',
    },
    title: {
      fontSize: 22,
      fontWeight: 'bold',
      color: '#006699',
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 10,
      marginRight: 10,
    },
    subtitle: {
      fontSize: 18,
      color: '#333',
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 10,
      marginRight: 10,
    },
    separator: {
      marginVertical: 30,
      height: 1,
      width: '80%',
    },
    paragraph: {
      fontSize: 16,
      color: '#333',
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 10,
      marginRight: 10,
    },
    imageContainer: {
      //flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
  
      width: Dimensions.get('window').width,
      height: 250,
      
    },
    image: {
      //flex: 1,
      //alignItems: 'center',
      //justifyContent: 'center',
  
      //height: 250,
      width: Dimensions.get('window').width,
      height: 250,
  
      resizeMode: 'contain',
  
      /*
      resizeMode: 'cover',
  
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 10,
      marginRight: 10,
  
      borderWidth: 1,
      borderColor: 'red'
      */
  
    }
  });